export type TransformParentLookup = (id: string) => string | null;

export function transformPathFromRoot(id: string, transformParentId: TransformParentLookup): string[] {
  const path: string[] = [id];
  const seen = new Set<string>(path);
  let cur = transformParentId(id);
  while (cur !== null && !seen.has(cur)) {
    path.push(cur);
    seen.add(cur);
    cur = transformParentId(cur);
  }
  path.reverse();
  return path;
}

export function resolveDrillSelection(
  selectedId: string,
  hitId: string,
  transformParentId: TransformParentLookup,
): string | null | undefined {
  const path = transformPathFromRoot(hitId, transformParentId);
  const selectedPos = path.indexOf(selectedId);
  if (selectedPos < 0) {
    return undefined;
  }
  if (selectedPos === path.length - 1) {
    return null;
  }
  return path[selectedPos + 1];
}
